<script>
import { onMounted } from "vue";
import TopNavbar from "./components/TopNavbar.vue";
import { useAuthStore } from "@/store/auth";
import ApiService from "@/services/ApiService";

export default {
  name: "App",
  components: {
    TopNavbar,
  },
  setup() {
    const authStore = useAuthStore();

    onMounted(() => {
      ApiService.trackVisit();
      if (authStore.isLoggedIn) {
        authStore.checkAttendance();
      }
    });

    return {};
  },
};
</script>

<template>
  <div class="app-container">
    <TopNavbar />

    <main class="main-content">
      <router-view />
    </main>
  </div>
</template>

<style>
/* --- 전역 변수 (Dark Theme) --- */
:root {
  --bg-deep: #0f111a; /* 메인 배경 (Deep Dark Navy) */
  --bg-card: #1b1d2a; /* 카드 배경 */
  --text-main: #ffffff; /* 메인 텍스트 */
  --text-sub: #b0b8c4; /* 서브 텍스트 */
  --border-color: rgba(255, 255, 255, 0.1);

  /* 네온 포인트 컬러 */
  --accent-purple: #a96bf7;
  --accent-blue: #539fe5;
  --accent-mint: #2fd5c6;
  --accent-orange: #ff9900;

  --header-height: 70px;
}

body {
  margin: 0;
  font-family: "Pretendard", -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, sans-serif;
  background-color: var(--bg-deep);
  color: var(--text-main);
  overflow-x: hidden; /* 가로 스크롤 방지 */
}

a {
  text-decoration: none;
  color: inherit;
}
ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
button {
  font-family: inherit;
}

.app-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.main-content {
  flex: 1;
  width: 100%;
  box-sizing: border-box;
  /* 상단바가 fixed이므로 겹치지 않게 패딩 추가 (HomePage 등에서 full화면 쓸 때는 페이지 내부에서 조정 가능) */
  padding-top: var(--header-height);
}

/* 스크롤바 커스텀 (Chrome/Safari) */
::-webkit-scrollbar {
  width: 8px;
}
::-webkit-scrollbar-track {
  background: var(--bg-deep);
}
::-webkit-scrollbar-thumb {
  background: #333;
  border-radius: 4px;
}
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>
